import { useCallback, useMemo } from 'react';

import { REORDER_ANNOTATIONS_STACKING } from '../actions';
import {
  getLayerOrderAvailability,
  reorderManyAnnotationsInStack,
} from '../utils/reorderAnnotationsInStack';
import useStore from './useStore';

const useReorderSelectedAnnotations = () => {
  const { dispatch, selectionsIds = [], annotations = {} } = useStore();

  const layerOrderState = useMemo(
    () => getLayerOrderAvailability(annotations, selectionsIds),
    [annotations, selectionsIds],
  );

  const reorder = useCallback(
    (direction) => {
      if (
        !layerOrderState.enabled ||
        !layerOrderState.directions[direction]
      ) {
        return false;
      }

      const nextAnnotations = reorderManyAnnotationsInStack(
        annotations,
        selectionsIds,
        direction,
      );

      if (nextAnnotations === annotations) {
        return false;
      }

      dispatch({
        type: REORDER_ANNOTATIONS_STACKING,
        payload: {
          annotationIds: selectionsIds,
          direction,
          nextAnnotations,
        },
      });

      return true;
    },
    [annotations, dispatch, layerOrderState, selectionsIds],
  );

  return {
    reorder,
    layerOrderState,
    /** @deprecated use layerOrderState.directions */
    reorderAvailability: layerOrderState.directions,
    hasSelection: selectionsIds.length > 0,
    selectionsIds,
  };
};

export default useReorderSelectedAnnotations;
